import React, { useRef, useState, useEffect } from "react";
import Tabs from "../components/headers/Tabs.jsx";
import Button from "../components/shared/Button.jsx";
import SubMenu from "../components/headers/SubMenu.jsx";
import { mainMenu } from "../constants/data.js";
import Dropdown from "../components/headers/Dropdown.jsx";
import { useLanguage } from "../contexts/LanguageContext"; // useLanguage hook'unu import edin

export function Header(props) {
  const headerRef = useRef();
  const { language } = useLanguage(); // Dil bilgisini context'ten alın

  // Seçili sekme ilk 3'te değilse (id > 3) otomatik olarak tüm sekmeleri göster
  const initialShowAllTabs = props.activeTabIndex > 3;
  const [showAllTabs, setShowAllTabs] = useState(initialShowAllTabs);

  useEffect(() => {
    if (props.activeTabIndex > 3) {
      setShowAllTabs(true);
    }
  }, [props.activeTabIndex]);

  const handleShowAllTabs = (value) => {
    setShowAllTabs(value);
  };

  return (
    <React.Fragment>
      <div className="flex bg-gray-100 justify-between px-4 items-center h-[90px] transition-all duration-500 ease-in-out relative">
        <Dropdown
          className="flex lg:hidden"
          setActiveTabIndex={props.setActiveTabIndex}
        />
        <Button name="TR" variant="outline" className="lg:hidden" />
        <div
          className="px-20 items-center justify-between w-full hidden lg:flex transition-all duration-500 ease-in-out"
          ref={headerRef}
        >
          <div
            className={`transition-all duration-500 ease-in-out ${
              showAllTabs
                ? "opacity-0 max-w-0 overflow-hidden transform -translate-x-10"
                : "opacity-100 max-w-[200px] transform translate-x-0"
            }`}
            style={{
              transitionDelay: showAllTabs ? "0ms" : "300ms",
            }}
          >
            <img
              src="https://proj-assets.onedio.com/sunum/mediazone.svg"
              alt="Mediazone Logo"
              className="transition-all duration-500"
            />
          </div>
          <div
            className={`transition-all duration-500 ease-in-out ${
              showAllTabs
                ? "w-full flex justify-center transform translate-x-0"
                : "transform translate-x-0"
            }`}
            style={{
              transitionDelay: "150ms",
            }}
          >
            <Tabs
              activeTabIndex={props.activeTabIndex}
              setActiveTabIndex={props.setActiveTabIndex}
              setShowAllTabs={handleShowAllTabs}
              showAllTabs={showAllTabs}
            />
          </div>
          <div
            className={`gap-3 hidden lg:flex transition-all duration-500 ease-in-out relative z-[90] ${
              showAllTabs
                ? "opacity-0 max-w-0 overflow-hidden transform translate-x-10"
                : "opacity-100 max-w-[300px] transform translate-x-0"
            }`}
            style={{
              transitionDelay: showAllTabs ? "0ms" : "300ms",
            }}
          >
            <Button
              name={language === "TR" ? "İletişim" : "Contact Us"}
              variant="normal"
            />
            <Button name="TR" variant="outline" />
          </div>
        </div>
      </div>
      <SubMenu
        item={mainMenu.filter((tab) => tab.id === props.activeTabIndex && tab)}
        headerRef={headerRef}
      />
    </React.Fragment>
  );
}
